<template>
  <div id="potential-classes">
    <h2 class="px-4 text-xl font-semibold sm:px-0 hidden">Potential Classes</h2>
    <div
      class="flex flex-col items-center justify-center px-4 pt-4 pb-12 mt-3 text-center bg-white border-t border-b border-gray-300 sm:border sm:rounded"
      v-if="potentialClasses.length === 0"
    >
      <img class="-mb-4" src="@/assets/images/no-search-result.svg" alt="" />
      <h3 class="mb-4 text-lg font-semibold md:text-xl md:mb-6">
        No classes found
      </h3>
      <p class="max-w-md.text-sm md:text-lg">
        We&rsquo;re sorry that there are no classes found at this time. Please
        try
        <a href="https://apiabroad.com/class-finder/" target="_blank"
          >https://apiabroad.com/class-finder/</a
        >
        to find potential classes for this student.
      </p>
    </div>
    <div class="grid gap-4" v-else>
      <div
        class="grid gap-3 px-4 py-4 mt-3 bg-white border-t border-b border-gray-300 sm:border sm:rounded"
        v-for="potentialClass in potentialClasses"
        :key="potentialClass.id"
      >
        <h3 class="text-lg">{{ potentialClass.title }}</h3>

        <div clas="grid grid-cols-2 gap-4">
          <div v-if="site">
            <p class="text-sm text-gray-500">{{ site }}</p>
          </div>
          <div v-if="potentialClass.term.length">
            <p class="text-sm text-gray-500">
              {{ joinItems(potentialClass.term) }}
            </p>
          </div>
        </div>
        <div v-if="potentialClass.description">
          <p>{{ potentialClass.description }}</p>
        </div>
        <table>
          <tbody>
            <tr v-if="potentialClass.languageOfInstruction.length">
              <th class="w-1/2" scope="row">
                Language of Instruction
              </th>
              <td class="w-1/2">
                {{ joinItems(potentialClass.languageOfInstruction) }}
              </td>
            </tr>
            <tr v-if="potentialClass.classCode">
              <th class="w-1/2" scope="row">
                Host University Class Code
              </th>
              <td class="w-1/2">{{ potentialClass.classCode }}</td>
            </tr>
            <tr v-if="potentialClass.syllabusLink">
              <th class="w-1/2" scope="row">
                Syllabus
              </th>
              <td class="w-1/2">
                <a
                  :href="potentialClass.syllabusLink"
                  v-if="potentialClass.syllabusLink"
                  target="_blank"
                >
                  View Syllabus
                </a>
              </td>
            </tr>
            <tr v-if="potentialClass.program.length">
              <th class="w-1/2" scope="row">
                Available Programs
              </th>
              <td class="w-1/2">
                {{ joinItems(potentialClass.program) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "potential-classes",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    programSessionId: {
      type: String,
      default: ""
    },
    site: {
      type: String,
      default: ""
    },
    programSalesforceId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      potentialClasses: [],
      programId: ""
    };
  },
  created() {
    this.getClasses();
  },
  methods: {
    async getClasses() {
      await this.$apollo
        .query({
          query: gql`
            query entries($salesforceId: [QueryArgument]) {
              entries(section: "programs", salesforceId: $salesforceId) {
                id
              }
            }
          `,
          variables: {
            salesforceId: this.programSalesforceId
          },
          client: "apolloClasses"
        })
        .then(response => {
          if (response.data.entries.length > 0) {
            this.programId = response.data.entries[0].id;
            this.getData();
          }
        })
        .catch(error => {
          console.log("Error something went wrong: " + error);
        });
    },
    async getData() {
      await this.$apollo
        .query({
          query: gql`
            query entries($relatedTo: [QueryArgument]) {
              entries(section: "classes", relatedTo: $relatedTo) {
                title
                ... on classes_classes_Entry {
                  description
                  syllabusLink
                  classCode
                  term {
                    title
                  }
                  languageOfInstruction {
                    title
                  }
                  program {
                    title
                  }
                }
              }
            }
          `,
          variables: {
            relatedTo: this.programId
          },
          client: "apolloClasses"
        })
        .then(response => {
          this.potentialClasses = response.data.entries;
        })
        .catch(error => {
          console.log("Error something went wrong: " + error);
        });
    },
    joinItems(items) {
      if (items) {
        return items
          .map(function(item) {
            return item.title;
          })
          .join(", ");
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
table {
  @apply w-full table-fixed;
}
table th {
  @apply py-2 pr-2;
  @apply text-xs tracking-widest text-left text-gray-500 uppercase align-top;
}
table td {
  @apply py-2 pl-2;
  @apply text-sm;
}
</style>
